window._mode='front';window._protocol='https://';window._domain='www.votre-etiquette.com';window._diroot='';window._theme='default';window._webdir='web';window._themedir='web/_themes/ve/';window._api='/api/v2/';
import Interface from 'theme/index.js';
import cwException from 'components/exception.js';
import { Fetch } from 'components/fetch.js';
import { getScript } from 'components/utils.js';
import Storage from 'components/storage.js';
import Placeholder from 'components/placeholder.js';
import Spinner from 'components/spinner.js';
import Favorites from 'theme/favorites.js';
import Prices from 'assets/custengine/components/prices.js';
import Fingerprint from 'components/fingerprint.js';

(async () => {

    await Interface();

    // ICONE FAVORIS DES MODELES
    Favorites();

    // SYSTEME DE PRIX
    Prices();


    // Stats de vues à partir de 5 secondes
    setTimeout(() =>
    {
        setStats();
    }, 5000);

    // Déplace le bloc id=ctz-model-cta à la fin du body afin de le mettre en position sticky en bas de l'écran sur mobile, a faire uniquement sur mobile !
    if (window.innerWidth < 991) {
        const cta = document.getElementById('ctz-model-cta');
        if (cta)
        {
            document.querySelector('body').appendChild(cta);
            cta.classList.add('sticky-bottom');
        }
    }

    // AVIS
    // On place la modal dans le body pour éviter les problèmes de z-index avec le backdrop
    document.querySelector('body').appendChild(document.getElementById('ctz-modal-review-post'));
    // On active la navigation au départ
    setReviewsNav();
    // On check false si on a déjà coché, pour désactiver le filtre
    Array.from(document.querySelectorAll('input[name="ctz_review_filter[]"]')).forEach(el =>
    {
        el.addEventListener('change', async event =>
        {
            getReviewsPage(1);        
        });
    });
    // Post review stars
    Array.from(document.querySelectorAll('.ctz-reviews-post-stars input[name="rating"]')).forEach(el =>
    {
        el.addEventListener('click', event =>
        {
            // On récupère l'index de l'étoile cliquée
            let rating = parseInt(el.value);
            // On met à jour les étoiles
            Array.from(document.querySelectorAll('.ctz-reviews-post-stars svg use')).forEach((star, i) =>
            {            
                // Remplace l'attribut xlink:href en utilisant createElementNS pour créer un nouvel élément <use>
                const ns = "http://www.w3.org/2000/svg";
                const xlinkNS = "http://www.w3.org/1999/xlink";
                const newUse = document.createElementNS(ns, "use");

                if (i+1 <= rating)
                {
                    newUse.setAttributeNS(xlinkNS, "href", star.getAttribute('href').split('#')[0] + "#ve4-star-full");
                }
                else
                {
                    newUse.setAttributeNS(xlinkNS, "href", star.getAttribute('href').split('#')[0] + "#ve4-star-empty");
                }
                star.parentNode.replaceChild(newUse, star);
            });
        });
    });
    //Soumission du formulaire d'avis
    document.querySelector('#ctz-modal-review-form').addEventListener('submit', event =>
    {
        Spinner.set({
            target: document.querySelector('#ctz-modal-review-form button[type="submit"]'),
            mode: 'button'
        });


        // On soumet le formulaire en ajax avec Fetch
        event.preventDefault();

        if (typeof Storage.get('recaptcha_key_site', 'core', 'session') !== 'undefined' && Storage.get('recaptcha_key_site', 'core', 'session') != '')
        {
            getScript('https://www.google.com/recaptcha/enterprise.js?render=' + Storage.get('recaptcha_key_site', 'core', 'session')).then(() =>
            {
                grecaptcha.enterprise.ready(() =>
                {
                    grecaptcha.enterprise.execute(Storage.get('recaptcha_key_site', 'core', 'session'), { action: 'submit' }).then( async (token) =>
                    {
                    

                        const input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = 'g-recaptcha-response';
                        input.value = token;
                        event.target.appendChild(input);

                        const formData = new FormData(event.target);
                        const res = await Fetch(`${_api}custengine/review/`, {
                            method: 'POST',
                            body: formData
                        });
                        const msg = await res.json();
                        if (res.status != 200)
                        {
                            throw new cwException(msg);
                        }
                        document.querySelector('#ctz-modal-review-html').classList.add('d-none');
                        document.querySelector('#ctz-modal-review-end').classList.remove('d-none');
                        document.querySelector('#ctz-modal-review-post .modal-footer button[type="submit"]').classList.add('d-none');
                        document.querySelector('#ctz-modal-review-post .modal-footer button.btn-secondary').classList.add('d-none');
                        document.querySelector('#ctz-modal-review-post .modal-footer button.btn-primary').classList.remove('d-none');
                    });
                });
            });
        }

    });



    const e = document.getElementById('ctz-unit-price-switch');
    e.addEventListener('click', event =>
    {
        document.querySelectorAll('#ctz-model-degressives .ctz-model-price').forEach(el =>
        {
            if (e.checked)
            {
                el.classList.add('d-none');
            }
            else
            {
                el.classList.remove('d-none');
            }
        });
        document.querySelectorAll('#ctz-model-degressives .ctz-model-price-unit').forEach(el =>
        {
            if (e.checked)
            {
                el.classList.remove('d-none');
            }
            else
            {
                el.classList.add('d-none');
            }
        });
    });
})();

    async function getReviewsPage(page = 1)
    {
        try
        {
            let query = {
                ratings: Array.from(document.querySelectorAll('input[name="ctz_review_filter[]"]:checked')).map(el => el.value),
                id_model: document.getElementById('ctz-id_model').value,
                lng: Storage.get('isolang', 'core', 'session'),
                page: page
            };

            setReviewsPlaceholder();
            
            const res = await Fetch(`${_api}custengine/reviews/?${new URLSearchParams(query)}`, {
                method: 'GET'
            });
            const msg = await res.json();
            if (res.status != 200)
            {
                throw new cwException(msg);
            }
            
            document.getElementById('ctz-reviews-list').innerHTML = msg.html;
            setReviewsNav();

            // On scroll vers le haut
            document.querySelector('#ctz-reviews-list').scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
        catch(e)
        {
            throw new cwException(e);
        }
    }



    function setReviewsNav()
    {
        Array.from(document.querySelectorAll('#ctz-reviews-pagination .page-item a')).forEach(a =>
        {
            a.addEventListener('click', async event =>
            {
                event.preventDefault();
                getReviewsPage(a.dataset.page);
            });
        });
    }


    function setReviewsPlaceholder()
    {
        Array.from(document.querySelectorAll('#ctz-reviews-list > div')).forEach(el =>
        {
            // Cas ou il n'y pas d'avis
            if (el.querySelector('h5') === null)
            {
                let width = el.offsetWidth;
                el.innerHTML = '';
                let line = Placeholder.element('line', '100%', '100%', ['rounded']);
                Placeholder.loading({
                    // containerClass:'',
                    content: line,
                    target: el,
                    width: width,
                });
                return;
            }
            
            // Titre
            let h5 = el.querySelector('h5');
            let width = h5.offsetWidth;
            h5.innerHTML = '';
            let line = Placeholder.element('line', '100%', '100%', ['rounded']);
            Placeholder.loading({
                // containerClass:'',
                content: line,
                target: h5,
                width: width,
            });

            // Etoiles
            Array.from(el.querySelectorAll('.ctz-reviews-stars > svg')).forEach(star =>
            {
                let parent = star.parentElement;
                star.remove();
                let circle = Placeholder.element('circle', '100%', '100%', ['rounded']);
                Placeholder.loading({
                    containerClass:'me-1',
                    content: circle,
                    target: parent,
                    width: 21,
                    height: 21
                });
            });

            // Details
            Array.from(el.querySelectorAll('.hstack > div:not(.vr)')).forEach(dt =>
            {

                let width = dt.offsetWidth;
                dt.innerHTML = '';
                let line = Placeholder.element('line', '100%', '100%', ['rounded']);
                Placeholder.loading({
                    content: line,
                    target: dt,
                    width: width
                });
            });

            // Texte
            let txt = el.querySelector('.ctz-reviews-review-text');
            width = txt.offsetWidth;
            txt.innerHTML = '';
            line = Placeholder.element('line', '100%', '100%', ['rounded']);
            Placeholder.loading({
                // containerClass:'',
                content: line,
                target: txt,
                width: width,
                height: 30
            });

            // Supprime la réponse si existe
            let response = el.querySelector('.ctz-reviews-review-answer');
            if (response)
            {
                response.remove();
            }
            
        });
    }


    async function setStats()
    {
        const id_model = document.getElementById('ctz-id_model').value;

        if (typeof id_model === 'undefined' || id_model == '' || isNaN(id_model))
        {
            return;
        }

        let ex = Storage.get('views_statistic', 'custengine', 'local');
        if (typeof ex === 'undefined' || ex === null || ex == '')
        {
            ex = [];
        }

        if (!ex.includes(id_model))
        {
            let fingerprint = Storage.get('fingerprint', 'custengine', 'local');

            
            if (typeof fingerprint === 'undefined' || fingerprint === null || fingerprint == '')
            {
                const fp = await Fingerprint();
                            
                const formData = new FormData();

                var dataBlob = new Blob([JSON.stringify(fp)], {
                    type: 'text/plain'
                });
                formData.append('data', dataBlob);
                const res = await Fetch(`${_api}custengine/fingerprint/`, {
                    method: 'POST',
                    body: formData
                });

                fingerprint = await res.json();
                if (res.status === 200)
                {
                    Storage.set('fingerprint', fingerprint, 'custengine', 'local');
                }
            }
            
            const res = await Fetch(`${_api}custengine/statistic/`, {
                method: 'POST',
                body: JSON.stringify({
                    id_model: id_model
                })
            });

            if (res.status === 200)
            {
                ex.push(id_model);
                Storage.set('views_statistic', ex, 'custengine', 'local');
            }
        }
    }
